<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    width: string;
    page: number;
    scale?: number;
    showPages?: boolean;
    showFooter?: boolean;
    footerTitle?: string | null;
    footerSubtitle?: string | null;
  }>(),
  {
    width: "210mm",
    scale: 1,
    showPages: true,
    page: 0,
  }
);
</script>

<template>
  <section
    class="page"
    :class="{
      pages: showPages,
      footer: showFooter,
      print: $store.getters.print,
    }"
  >
    <div class="content">
      <slot></slot>
    </div>

    <template v-if="showFooter">
      <div class="footer">
        <div class="title">
          {{ footerTitle }}
        </div>
        <div class="subtitle">
          {{ footerSubtitle }}
        </div>
      </div>
    </template>

    <template v-if="showPages">
      <div class="page-number">
        {{ page }}
      </div>
    </template>
  </section>
</template>

<style lang="scss" scoped>
$width: calc(v-bind("width") * v-bind("$props.scale"));
$height: calc((v-bind("width") * 1.41) * v-bind("$props.scale"));
$fontSize: calc(1rem * v-bind("$props.scale"));

.page {
  display: flex;
  flex-direction: column;
  width: $width;
  height: $height;
  max-height: $height;
  font-size: $fontSize;
  page-break-after: always;
  border: 1px solid var(--border);

  &.print {
    border: none;
  }

  .content {
    flex: 1;
  }

  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.15em;
    width: 90%;
    margin-inline: auto;
    padding-block-start: 0.25em;
    border-block-start: 1px solid var(--border);

    .title {
      font-size: 0.9em;
      text-transform: uppercase;
    }

    .subtitle {
      font-size: 0.75em;
    }
  }

  .page-number {
    display: flex;
    width: 90%;
    margin-inline: auto;
    height: 1.5em;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
    font-size: 1em;
    font-weight: bold;
    margin-bottom: 2em;
  }
}
</style>